import '@/index.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider } from './context/AuthContext';
import { BrandingProvider } from './context/BrandingContext';
import ProtectedRoute from './components/ProtectedRoute';
import ModuleGate from './components/ModuleGate';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Companies from './pages/Companies';
import Users from './pages/Users';
import Organization from './pages/Organization';
import Roles from './pages/Roles';
import AuditLogs from './pages/AuditLogs';
import Notifications from './pages/Notifications';
import NotificationPreferences from './pages/NotificationPreferences';
import ActionInbox from './pages/ActionInbox';
import Profile from './pages/Profile';
import EmployeeProfile from './pages/EmployeeProfile';
import ESSStatutoryForms from './pages/ESSStatutoryForms';
import HRESSApprovals from './pages/HRESSApprovals';
import IncrementWorkbench from './pages/IncrementWorkbench';
import DocumentTemplatesMaster from './pages/DocumentTemplatesMaster';
import AppointmentOrderGenerator from './pages/AppointmentOrderGenerator';
import ESSAppointmentOrder from './pages/ESSAppointmentOrder';
import Masters from './pages/Masters';
import MasterSetup from './pages/MasterSetup';
import AssetDocumentTypeMasters from './pages/AssetDocumentTypeMasters';
import TaxSlabMaster from './pages/TaxSlabMaster';
import TDSValidationReport from './pages/TDSValidationReport';
import ESSAssetsDocs from './pages/ESSAssetsDocs';
import MonthlyInput from './pages/MonthlyInput';
import Employees from './pages/Employees';
import EmployeeAssetsDocs from './pages/EmployeeAssetsDocs';
import AttendanceDashboard from './pages/AttendanceDashboard';
import DailyAttendance from './pages/DailyAttendance';
import MonthlyAttendance from './pages/MonthlyAttendance';
import PunchLogs from './pages/PunchLogs';
import RegularizationInbox from './pages/RegularizationInbox';
import ExceptionsDashboard from './pages/ExceptionsDashboard';
import OTApproval from './pages/OTApproval';
import ShiftRoster from './pages/ShiftRoster';
import LeaveManagement from './pages/LeaveManagement';
import PayrollSetup from './pages/PayrollSetup';
import SalaryStructures from './pages/SalaryStructures';
import CTCPlanner from './pages/CTCPlanner';
import PayrollRun from './pages/PayrollRun';
import PageErrorBoundary from './components/PageErrorBoundary';
import PayrollExceptions from './pages/PayrollExceptions';
import PayrollApproval from './pages/PayrollApproval';
import Payslips from './pages/Payslips';
import TaxSheets from './pages/TaxSheets';
import FullAndFinal from './pages/FullAndFinal';
import ArrearsRevision from './pages/ArrearsRevision';
import StatutorySetup from './pages/StatutorySetup';
import StatutoryStateRates from './pages/StatutoryStateRates';
import StatutoryMasters from './pages/StatutoryMasters';
import HealthInsuranceMaster from './pages/HealthInsuranceMaster';
import SelectivePayrollRerun from './pages/SelectivePayrollRerun';
import ConsolidatedApproval from './pages/ConsolidatedApproval';
import LineItemApprovalWorkflows from './pages/LineItemApprovalWorkflows';
import LineItemApprovalInbox from './pages/LineItemApprovalInbox';
import LineItemApprovalDashboard from './pages/LineItemApprovalDashboard';
import EmployeeStatutoryEligibility from './pages/EmployeeStatutoryEligibility';
import DeclarationProof from './pages/DeclarationProof';
import TDSProjection from './pages/TDSProjection';
import StatutoryWorking from './pages/StatutoryWorking';
import ChallanPreparation from './pages/ChallanPreparation';
import MonthlyStatutoryRegister from './pages/MonthlyStatutoryRegister';
import AnnualTaxWorksheet from './pages/AnnualTaxWorksheet';
import ComplianceDashboard from './pages/ComplianceDashboard';
import ESSPortal from './pages/ESSPortal';
import ESSUserGuide from './pages/ESSUserGuide';
import ESSAdvanceLedger from './pages/ESSAdvanceLedger';
import AdvanceLedger from './pages/AdvanceLedger';
import FinancePayments from './pages/FinancePayments';
import ESSLeaveAttendance from './pages/ESSLeaveAttendance';
import ESSPayTax from './pages/ESSPayTax';
import ESSDocuments from './pages/ESSDocuments';
import HelpDesk from './pages/HelpDesk';
import HelpDeskTracker from './pages/HelpDeskTracker';
import AttendanceUpload from './pages/AttendanceUpload';
import AttendanceUploadHistory from './pages/AttendanceUploadHistory';
import InternalAttendance from './pages/InternalAttendance';
import AttendanceCalculation from './pages/AttendanceCalculation';
import AttendanceReports from './pages/AttendanceReports';
import LeavePolicy from './pages/LeavePolicy';
import LeaveBalances from './pages/LeaveBalances';
import DataReset from './pages/DataReset';
import ManagerDashboard from './pages/ManagerDashboard';
import ManagerApprovals from './pages/ManagerApprovals';
import HRWorkbench from './pages/HRWorkbench';
import HRBench from './pages/HRBench';
import HRBenchReports from './pages/HRBenchReports';
import AdvanceSettlements from './pages/AdvanceSettlements';
import AdvanceSettlementReports from './pages/AdvanceSettlementReports';
import ReportsCenter from './pages/ReportsCenter';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import FinanceControls from './pages/FinanceControls';
import QADashboard from './pages/QADashboard';
import BusinessControls from './pages/BusinessControls';
import TenantManagement from './pages/TenantManagement';
import ModuleControl from './pages/ModuleControl';
import TenantSetupWizard from './pages/TenantSetupWizard';
import LoansAdmin from './pages/LoansAdmin';
import ReimbursementPolicy from './pages/ReimbursementPolicy';
import ReimbursementsAdvancesTracker from './pages/ReimbursementsAdvancesTracker';
import LoanPolicy from './pages/LoanPolicy';
import KYCCycles from './pages/KYCCycles';
import KYCCorrections from './pages/KYCCorrections';
import ESSKycConfirmation from './pages/ESSKycConfirmation';
import ESSExpenseClaims from './pages/ESSExpenseClaims';
import ApprovalWorkflows from './pages/ApprovalWorkflows';
import ApprovalReports from './pages/ApprovalReports';
import ExpenseClaimsAdmin from './pages/ExpenseClaimsAdmin';
import LegacyPayrollImports from './pages/LegacyPayrollImports';
import LegacyPayrollVariances from './pages/LegacyPayrollVariances';
import WageMaster from './pages/WageMaster';
import EmployeeCTCBulkUpload from './pages/EmployeeCTCBulkUpload';
import ProcessingGuide from './pages/ProcessingGuide';
import SalaryRevision from './pages/SalaryRevision';
import BiometricLogs from './pages/BiometricLogs';
import BiometricMapping from './pages/BiometricMapping';
import ETimeTrackLiteImport from './pages/ETimeTrackLiteImport';
import GeofenceSetup from './pages/GeofenceSetup';
import AttendanceExceptions from './pages/AttendanceExceptions';
import FaceAttendanceLogs from './pages/FaceAttendanceLogs';
import FacePunch from './pages/FacePunch';
import TDSOverrideRegister from './pages/TDSOverrideRegister';
import TravelDesk from './pages/TravelDesk';
import TravelLayout from './components/TravelLayout';
import ESSTravelRequests from './pages/ESSTravelRequests';
import TravelDashboard from './pages/travel/TravelDashboard';
import TravelRequestsList from './pages/travel/TravelRequestsList';
import NewTravelRequest from './pages/travel/NewTravelRequest';
import TravelRequestDetail from './pages/travel/TravelRequestDetail';
import EditTravelRequest from './pages/travel/EditTravelRequest';
import TravelApprovalInbox from './pages/travel/TravelApprovalInbox';
import TravelBookingDesk from './pages/travel/TravelBookingDesk';
import TravelCabBooking from './pages/travel/TravelCabBooking';
import TravelHotelBooking from './pages/travel/TravelHotelBooking';
import TravelPolicyMaster from './pages/travel/TravelPolicyMaster';
import TravelPolicyMapping from './pages/travel/TravelPolicyMapping';
import TravelBudgets from './pages/travel/TravelBudgets';
import TravelCreditCards from './pages/travel/TravelCreditCards';
import TravelVendorManagement from './pages/travel/TravelVendorManagement';
import TravelReports from './pages/travel/TravelReports';
import TravelSettings from './pages/travel/TravelSettings';
import { Toaster } from './components/ui/sonner';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
        <BrowserRouter>
          <ScrollToTop />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companies"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin']}>
                <ModuleGate><Companies /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin']}>
                <ModuleGate><Users /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/organization"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin']}>
                <ModuleGate><Organization /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/setup"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin']}>
                <TenantSetupWizard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/roles"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin']}>
                <ModuleGate><Roles /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/audit-logs"
            element={
              <ProtectedRoute
                allowedRoles={['tenant_admin', 'hr_admin', 'finance_reviewer']}
              >
                <ModuleGate><AuditLogs /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications/preferences"
            element={
              <ProtectedRoute>
                <NotificationPreferences />
              </ProtectedRoute>
            }
          />
          <Route
            path="/action-inbox"
            element={
              <ProtectedRoute
                allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer', 'department_manager']}
              >
                <ActionInbox />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          {/* Stage 73.20cu — Full employee profile with Request-Change workflow */}
          <Route
            path="/employee-profile"
            element={
              <ProtectedRoute>
                <EmployeeProfile />
              </ProtectedRoute>
            }
          />
          {/* Stage 73.20cv — ESS Statutory Forms (Joining, Form F, Gratuity, Health) */}
          <Route
            path="/ess/statutory-forms"
            element={
              <ProtectedRoute>
                <ESSStatutoryForms />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/health-insurance"
            element={
              <ProtectedRoute>
                <ESSStatutoryForms initialTab="health_insurance" />
              </ProtectedRoute>
            }
          />
          {/* Stage 73.20cu/cv — HR approvals for change requests + statutory forms */}
          <Route
            path="/hr/ess-approvals"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'hr_manager', 'payroll_admin', 'payroll_manager', 'super_admin']}>
                <HRESSApprovals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr/health-insurance-master"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'hr_manager', 'payroll_admin', 'payroll_manager', 'super_admin']}>
                <HealthInsuranceMaster />
              </ProtectedRoute>
            }
          />
          {/* Stage 73.20cz — Increment Workbench (anniversary alerts + workflow) */}
          <Route
            path="/hr/increment-workbench"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'hr_manager', 'payroll_admin', 'department_manager', 'super_admin']}>
                <IncrementWorkbench />
              </ProtectedRoute>
            }
          />
          {/* Document Templates & Appointment Order Engine Routes */}
          <Route
            path="/hr/document-templates"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'hr_manager', 'payroll_admin', 'super_admin']}>
                <DocumentTemplatesMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr/appointment-orders"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'hr_manager', 'payroll_admin', 'super_admin']}>
                <AppointmentOrderGenerator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/appointment-order"
            element={
              <ProtectedRoute>
                <ESSAppointmentOrder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/setup"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'attendance_admin']}>
                <ModuleGate><MasterSetup /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/asset-document-types"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'super_admin', 'hr_admin', 'payroll_admin']}>
                <ModuleGate><AssetDocumentTypeMasters /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters/tax-slabs"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'super_admin', 'hr_admin', 'payroll_admin']}>
                <ModuleGate><TaxSlabMaster /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/tds-validation"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'super_admin', 'hr_admin', 'payroll_admin', 'payroll_processor']}>
                <ModuleGate><TDSValidationReport /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/approvals"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'super_admin', 'hr_admin', 'payroll_admin']}>
                <ModuleGate><ApprovalReports /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/assets-docs"
            element={
              <ProtectedRoute>
                <ModuleGate><ESSAssetsDocs /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/monthly-inputs"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin']}>
                <ModuleGate><MonthlyInput /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/masters"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin']}>
                <ModuleGate><Masters /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/employees"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin']}>
                <ModuleGate><Employees /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/employees/:employee_id/assets-docs"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin']}>
                <ModuleGate><EmployeeAssetsDocs /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin', 'department_manager']}>
                <ModuleGate><AttendanceDashboard /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/daily"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin', 'department_manager']}>
                <ModuleGate><DailyAttendance /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/monthly"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin', 'department_manager']}>
                <ModuleGate><MonthlyAttendance /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/punches"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin']}>
                <ModuleGate><PunchLogs /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/regularization"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin', 'department_manager']}>
                <ModuleGate><RegularizationInbox /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/exceptions"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin']}>
                <ModuleGate><ExceptionsDashboard /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/ot-approval"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'department_manager']}>
                <ModuleGate><OTApproval /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/roster"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin']}>
                <ModuleGate><ShiftRoster /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/biometric"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin']}>
                <ModuleGate><BiometricLogs /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/biometric/mapping"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin']}>
                <ModuleGate><BiometricMapping /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/biometric/import"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin']}>
                <ModuleGate><ETimeTrackLiteImport /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/geofence"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin']}>
                <ModuleGate><GeofenceSetup /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/exception-register"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin']}>
                <ModuleGate><AttendanceExceptions /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/face-logs"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'attendance_admin']}>
                <ModuleGate><FaceAttendanceLogs /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance/face-punch"
            element={
              <ProtectedRoute>
                <ModuleGate><FacePunch /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/leave"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'department_manager']}>
                <ModuleGate><LeaveManagement /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/setup"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'finance_reviewer']}>
                <ModuleGate><PayrollSetup /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/structures"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><SalaryStructures /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/ctc-planner"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><CTCPlanner /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/run"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><PageErrorBoundary><PayrollRun /></PageErrorBoundary></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/exceptions"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><PayrollExceptions /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/approval"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'finance_reviewer']}>
                <ModuleGate><PayrollApproval /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/payslips"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'finance_reviewer', 'employee']}>
                <ModuleGate><Payslips /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/tax-sheets"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'finance_reviewer', 'payroll_processor']}>
                <ModuleGate><TaxSheets /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/fnf"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><FullAndFinal /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/arrears"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><ArrearsRevision /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/loans"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'finance_reviewer']}>
                <ModuleGate><LoansAdmin /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/reimbursement-policy"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><ReimbursementPolicy /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/reimbursements-tracker"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'finance_reviewer']}>
                <ModuleGate><ReimbursementsAdvancesTracker /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/loan-policy"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><LoanPolicy /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/kyc-cycles"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><KYCCycles /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/kyc-corrections"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><KYCCorrections /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/kyc"
            element={
              <ProtectedRoute>
                <ESSKycConfirmation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/expense-claims"
            element={
              <ProtectedRoute>
                <ESSExpenseClaims />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/travel-requests"
            element={
              <ProtectedRoute>
                <ESSTravelRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/travel-desk"
            element={<Navigate to="/travel/dashboard" replace />}
          />
          <Route
            path="/travel-desk/*"
            element={<Navigate to="/travel/dashboard" replace />}
          />

          {/* Nested Travel Desk Module Routing */}
          <Route
            path="/travel"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer', 'department_manager', 'employee', 'super_admin']}>
                <TravelLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route
              path="dashboard"
              element={<ModuleGate><TravelDashboard /></ModuleGate>}
            />
            <Route
              path="requests"
              element={<ModuleGate><TravelRequestsList /></ModuleGate>}
            />
            <Route
              path="request/new"
              element={<ModuleGate><NewTravelRequest /></ModuleGate>}
            />
            <Route
              path="request/:id"
              element={<ModuleGate><TravelRequestDetail /></ModuleGate>}
            />
            <Route
              path="request/:id/edit"
              element={<ModuleGate><EditTravelRequest /></ModuleGate>}
            />
            <Route
              path="approval"
              element={<ModuleGate><TravelApprovalInbox /></ModuleGate>}
            />
            <Route path="approvals" element={<Navigate to="/travel/approval" replace />} />
            <Route
              path="booking"
              element={<ModuleGate><TravelBookingDesk /></ModuleGate>}
            />
            <Route path="bookings" element={<Navigate to="/travel/booking" replace />} />
            <Route
              path="cab-booking"
              element={<ModuleGate><TravelCabBooking /></ModuleGate>}
            />
            <Route path="cabs-hotels" element={<Navigate to="/travel/cab-booking" replace />} />
            <Route
              path="hotel-booking"
              element={<ModuleGate><TravelHotelBooking /></ModuleGate>}
            />
            <Route
              path="policy"
              element={<ModuleGate><TravelPolicyMaster /></ModuleGate>}
            />
            <Route path="policies" element={<Navigate to="/travel/policy" replace />} />
            <Route
              path="policy-mapping"
              element={<ModuleGate><TravelPolicyMapping /></ModuleGate>}
            />
            <Route
              path="budget"
              element={<ModuleGate><TravelBudgets /></ModuleGate>}
            />
            <Route path="budgets" element={<Navigate to="/travel/budget" replace />} />
            <Route
              path="credit-cards"
              element={<ModuleGate><TravelCreditCards /></ModuleGate>}
            />
            <Route
              path="vendors"
              element={<ModuleGate><TravelVendorManagement /></ModuleGate>}
            />
            <Route
              path="reports"
              element={<ModuleGate><TravelReports /></ModuleGate>}
            />
            <Route
              path="settings"
              element={<ModuleGate><TravelSettings /></ModuleGate>}
            />
          </Route>
          <Route
            path="/payroll/approval-workflows"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><ApprovalWorkflows /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/expense-claims-admin"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'finance_reviewer']}>
                <ModuleGate><ExpenseClaimsAdmin /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/legacy-imports"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><LegacyPayrollImports /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/legacy-imports/:import_id"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><LegacyPayrollVariances /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/wage-master"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><WageMaster /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/employee-ctc-upload"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><EmployeeCTCBulkUpload /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/processing-guide"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'attendance_admin', 'finance_reviewer']}>
                <ProcessingGuide />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/salary-revision"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><SalaryRevision /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statutory/setup"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><StatutorySetup /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statutory/state-rates"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><StatutoryStateRates /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statutory/masters"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'super_admin']}>
                <ModuleGate><StatutoryMasters /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payroll/rerun/:runId"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'super_admin', 'payroll_processor']}>
                <ModuleGate><SelectivePayrollRerun /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/consolidated-approval"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'super_admin', 'payroll_processor', 'hr_manager', 'payroll_manager', 'cfo', 'director', 'finance_admin']}>
                <ModuleGate><ConsolidatedApproval /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/line-item-approval/workflows"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'super_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><LineItemApprovalWorkflows /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/line-item-approval/inbox"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'super_admin', 'payroll_admin', 'hr_admin', 'payroll_processor', 'payroll_manager', 'hr_manager', 'cfo', 'director', 'finance_admin', 'department_manager', 'manager', 'employee']}>
                <ModuleGate><LineItemApprovalInbox /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/line-item-approval/dashboard"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'super_admin', 'payroll_admin', 'hr_admin', 'payroll_processor', 'payroll_manager', 'hr_manager', 'cfo', 'director', 'finance_admin']}>
                <ModuleGate><LineItemApprovalDashboard /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statutory/eligibility"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><EmployeeStatutoryEligibility /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statutory/declarations"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'employee']}>
                <ModuleGate><DeclarationProof /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statutory/tds-projection"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><TDSProjection /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statutory/working"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><StatutoryWorking /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statutory/challans"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><ChallanPreparation /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statutory/register"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'finance_reviewer']}>
                <ModuleGate><MonthlyStatutoryRegister /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statutory/tax-worksheet"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <ModuleGate><AnnualTaxWorksheet /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/statutory/compliance"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'finance_reviewer']}>
                <ModuleGate><ComplianceDashboard /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/portal"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer', 'department_manager', 'attendance_admin', 'employee']}>
                <ESSPortal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/user-guide"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer', 'department_manager', 'attendance_admin', 'employee', 'super_admin']}>
                <ESSUserGuide />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/advance-ledger"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer', 'department_manager', 'attendance_admin', 'employee', 'super_admin']}>
                <ESSAdvanceLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/advance-ledger"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'super_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer']}>
                <ModuleGate><AdvanceLedger /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/payments"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'super_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer']}>
                <ModuleGate><FinancePayments /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/leave-attendance"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer', 'department_manager', 'attendance_admin', 'employee']}>
                <ESSLeaveAttendance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/pay-tax"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer', 'department_manager', 'attendance_admin', 'employee']}>
                <ESSPayTax key="pay-tax" />
              </ProtectedRoute>
            }
          />
          {/* Stage 73.20cw — Reimbursements + Loans moved to Expense Claims section.
              Same ESSPayTax component in single-module mode — APIs / data / flow unchanged. */}
          <Route
            path="/ess/reimbursements"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer', 'department_manager', 'attendance_admin', 'employee']}>
                <ESSPayTax key="reimbursement" mode="reimbursement" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/loans"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer', 'department_manager', 'attendance_admin', 'employee']}>
                <ESSPayTax key="loan" mode="loan" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/documents"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer', 'department_manager', 'attendance_admin', 'employee']}>
                <ESSDocuments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ess/helpdesk"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer', 'department_manager', 'attendance_admin', 'employee']}>
                <HelpDesk />
              </ProtectedRoute>
            }
          />
          <Route
            path="/helpdesk/tracker"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'attendance_admin', 'finance_reviewer', 'department_manager']}>
                <HelpDeskTracker />
              </ProtectedRoute>
            }
          />
          <Route path="/attendance/upload" element={<ProtectedRoute allowedRoles={['tenant_admin','hr_admin','attendance_admin']}><AttendanceUpload/></ProtectedRoute>} />
          <Route path="/attendance/history" element={<ProtectedRoute allowedRoles={['tenant_admin','hr_admin','attendance_admin']}><AttendanceUploadHistory/></ProtectedRoute>} />
          <Route path="/attendance/internal" element={<ProtectedRoute allowedRoles={['tenant_admin','hr_admin','attendance_admin']}><InternalAttendance/></ProtectedRoute>} />
          <Route path="/attendance/calculation" element={<ProtectedRoute allowedRoles={['tenant_admin','hr_admin','attendance_admin','payroll_admin']}><AttendanceCalculation/></ProtectedRoute>} />
          <Route path="/attendance/reports" element={<ProtectedRoute allowedRoles={['tenant_admin','hr_admin','attendance_admin','payroll_admin','finance_reviewer','department_manager']}><AttendanceReports/></ProtectedRoute>} />
          <Route path="/leave-policy" element={<ProtectedRoute allowedRoles={['tenant_admin','hr_admin']}><LeavePolicy/></ProtectedRoute>} />
          <Route path="/leave-policy/balances" element={<ProtectedRoute allowedRoles={['tenant_admin','hr_admin','payroll_admin']}><LeaveBalances/></ProtectedRoute>} />
          <Route path="/leave-balances" element={<ProtectedRoute allowedRoles={['tenant_admin','hr_admin','payroll_admin']}><LeaveBalances/></ProtectedRoute>} />
          <Route path="/admin/data-reset" element={<ProtectedRoute allowedRoles={['tenant_admin','hr_admin']}><DataReset/></ProtectedRoute>} />
          <Route
            path="/manager/dashboard"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'department_manager', 'is_reporting_manager']}>
                <ManagerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manager/approvals"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'department_manager', 'is_reporting_manager']}>
                <ManagerApprovals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr-workbench"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin']}>
                <HRWorkbench />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr-bench"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'hr_manager', 'payroll_admin', 'finance_reviewer']}>
                <ModuleGate><HRBench /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/hr-bench/reports"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'hr_manager', 'payroll_admin', 'finance_reviewer']}>
                <ModuleGate><HRBenchReports /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/advance-settlements"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer']}>
                <ModuleGate><AdvanceSettlements /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/advance-settlements/reports"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer']}>
                <ModuleGate><AdvanceSettlementReports /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer']}>
                <ModuleGate><ReportsCenter /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin', 'finance_reviewer']}>
                <ModuleGate><AnalyticsDashboard /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'finance_reviewer']}>
                <ModuleGate><FinanceControls /></ModuleGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/qa"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <QADashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/business-controls"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'hr_admin', 'payroll_admin']}>
                <BusinessControls />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tds-overrides"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin']}>
                <TDSOverrideRegister />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/tds-override-register"
            element={
              <ProtectedRoute allowedRoles={['tenant_admin', 'payroll_admin', 'hr_admin', 'finance_reviewer']}>
                <TDSOverrideRegister />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tenants"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <TenantManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/module-control"
            element={
              <ProtectedRoute allowedRoles={['super_admin']}>
                <ModuleControl />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      </BrandingProvider>
    </AuthProvider>
  );
}

export default App;
